
import { Image, useScroll } from "@react-three/drei"
import { useFrame } from "@react-three/fiber"
import { useRef } from "react"
import { mainStore } from "../../store"


export default function Microbiote(props)
{

    const group = useRef()

    const data = useScroll()

    const colors = mainStore.useStore(s => s.colors)


    useFrame(() => {
        group.current.children[0].position.z = 1.6 - data.range(0, 1 / 3) / 2
        group.current.children[1].position.z = 1.25 - data.range(0, 1 / 3) / 3
    }) 


    return <group ref={ group } { ...props }>
        <Image
            url={import.meta.env.BASE_URL + 'static/img/microbiote.webp'}
            transparent
            scale={3}
            zoom={0.7}
            segments={4}
            position={[1.7, 0, 1.4]}
            rotation={[0, 0, 0]}
            toneMapped={false}
            color={colors.clear}
        />

        <Image
            url={import.meta.env.BASE_URL + 'static/img/microbiote-bg.webp'}
            transparent
            scale={3.2}
            zoom={0.75 }
            segments={4}
            position={[1.5, -0.1, 1.25]}
            rotation={[0, 0, 0]}
            toneMapped={false}
            color={colors.clear}
        />
    </group>
}